import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { IPartImagesResponse } from "../models/Part";
import { IPartImage } from './../models/Part';


export default function useEndSlateImages() {
  const { get, post, postDocs, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const endSlateImages = useQuery({
    queryKey: ["endSlateImages"],
    queryFn: () => get<IPartImagesResponse>("/part/endslates"),
  });

  // const create = useMutation(
  //   (job: CreateJobRequest) => post(`/job`, job),
  //   {
  //     onSuccess: () => {
  //       queryClient.invalidateQueries(["endSlateImages"]);
  //     },
  //   }
  // );

  const upload = useMutation(
    (data: FormData) => postDocs(`/part/endslates/upload`, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["endSlateImages"]);
      },
    }
  );

  const update = useMutation(
    (endSlate: any) => put(`/part/endslates/${endSlate.id}`, endSlate),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["endSlateImages"]);
      },
    }
  );

  const remove = useMutation(
    (id: string) => del(`/part/endslates/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["endSlateImages"]);
      },
    }
  );

  return {
    endSlateImages,
    // create,
    upload,
    update,
    remove
  };
}
